<template>
  <validation-observer
    ref="saveFormRef"
    #default="{invalid}"
  >
    <b-modal
      id="credentialStorageSaveModal"
      body-class="position-static"
      centered
      :title="isCreated ? 'Bổ sung' : 'Chỉnh sửa'"
      no-close-on-backdrop
      size="lg"
      @show="onShow"
      @hidden="onHide"
    >
      <b-form>
        <b-row>
          <b-col>
            <b-form-group label-for="credentialId">
              <template v-slot:label>
                Văn bằng, chứng chỉ<span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Văn bằng, chứng chỉ"
                rules="required"
              >
                <v-select
                  v-model="targetItem.credentialId"
                  :options="credentialsDropdown"
                  :reduce="option => option.value"
                />
                <b-form-invalid-feedback :state="getElementState(errors)">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              v-if="credentialProcessReq && isCreated"
            >
              <template v-slot:label>
                Lựa chọn file bản sao văn bằng, chứng chỉ của sinh viên để thêm vào hệ thống<span class="text-danger">*</span>
                <p style="color: red; font-style: italic;">
                  Chú ý: File bản sao cần phải ở định dạng file pdf
                </p>
              </template>
              <b-form-radio-group
                ref="credentialFileGroup"
                v-model="targetItem.credentialFileId"
                :options="options"
                name="radios-stacked"
                stacked
                option-value="value"
                option-text="text"
                @change="checkPdfExtension"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <b-form-group label-for="trainingSystemId">
              <template v-slot:label>
                {{ trainingSystemLabel }}<span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                :name="trainingSystemLabel"
                rules="required"
              >
                <v-select
                  v-model="targetItem.trainingSystemId"
                  :options="trainingSystems"
                  :reduce="option => option.id"
                  label="name"
                  :placeholder="trainingSystemLabel"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label-for="courseId">
              <template v-slot:label>
                Khóa học<span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Khóa học"
                rules="required"
              >
                <v-select
                  v-model="targetItem.courseId"
                  :options="courses"
                  :reduce="option => option.id"
                  label="name"
                  placeholder="Khóa học"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            cols="6"
          >
            <b-form-group label-for="name">
              <template v-slot:label>
                Lớp cố định<span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Lớp cố định"
                rules="required"
              >
                <v-select
                  v-model="targetItem.classCode"
                  :options="classes"
                  :reduce="option => option.code"
                  label="name"
                  placeholder="Lớp cố định"
                  :state="getElementState(errors)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            cols="6"
          >
            <b-form-group label-for="studentCode">
              <template v-slot:label>
                Mã sinh viên<span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Mã sinh viên"
                rules="required"
              >
                <v-select
                  v-model="targetItem.studentCode"
                  :options="studentClasses"
                  :reduce="option => option.code"
                  label="name"
                  placeholder="Mã sinh viên"
                  :state="getElementState(errors)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            cols="6"
          >
            <b-form-group label-for="yearCode">
              <template v-slot:label>
                Năm cấp
              </template>
              <v-select
                v-model="targetItem.yearCode"
                :options="schoolYears"
                :reduce="option => option.code"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="6"
          >
            <b-form-group label-for="studyClassificationCode">
              <template v-slot:label>
                Xếp loại
              </template>
              <v-select
                v-model="targetItem.studyClassificationCode"
                :options="studyClassifications"
                :reduce="option => option.code"
                label="name"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group label-for="decisionNo">
              <template v-slot:label>
                Số quyết định
              </template>
              <b-form-input
                id="decisionNo"
                v-model="targetItem.decisionNo"
                placeholder="Số quyết định"
              />
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group label-for="code">
              <template v-slot:label>
                Số hiệu
              </template>
              <b-form-input
                id="code"
                v-model="targetItem.code"
                placeholder="Số hiệu"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label-for="codeCredentialStorage">
              <template v-slot:label>
                Số vào sổ gốc
              </template>
              <b-form-input
                id="codeCredentialStorage"
                v-model="targetItem.codeCredentialStorage"
                placeholder="Số vào sổ gốc"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label-for="status">
              <template v-slot:label>
                Trạng thái <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Trạng thái"
                rules="required"
              >
                <v-select
                  v-model="targetItem.status"
                  :options="statusOptions"
                  :reduce="option => option.value"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-group
              label="File văn bằng, chứng chỉ (Excel hoặc PDF)"
              label-for="file"
            >
              <b-form-file
                ref="inputFileRef"
                :placeholder="targetItem.credentialFileName ? targetItem.credentialFileName : 'File văn bằng, chứng chỉ'"
                @change="uploadFile"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>

      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave('hide')"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu lại
            </span>
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            @click="$bvModal.hide('credentialStorageSaveModal')"
          >
            <span class="text-right">
              <feather-icon icon="XIcon" /> Hủy
            </span>
          </b-button>
        </div>
      </template>
    </b-modal>
  </validation-observer>
</template>
<script>

import {
  BButton, BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback, BFormRadioGroup,
  BModal,
  BRow, BFormFile,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { getUser } from '@/auth/utils'
import { required } from '@core/utils/validations/validations'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import apiCommon from '@/views/apiCommon'
import { OrganizationCode } from '@/const/code'
import api from './api'

export default {
  name: 'CredentialStorageSave',
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BModal,
    BForm,
    BFormInvalidFeedback,
    BFormRadioGroup,
    BButton,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
  },
  directives: {
    Ripple,
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {},
    },
    credentialProcessReq: {
      type: Object,
    },
  },
  data() {
    return {
      user: getUser(),
      isLoading: false,
      trainingSystems: [],
      courses: [],
      classes: [],
      studentClasses: [],
      studyClassifications: [],
      targetItem: {
        trainingSystemId: '',
        courseId: '',
        classId: '',
        credentialId: '',
        classCode: '',
        studentCode: '',
        decisionNo: '',
        code: '',
        studyClassificationCode: '',
        yearCode: '',
        status: 1,
        credentialFileId: null,
        credentialFileName: '',
        studentId: '',
        id: null,
      },
      required,
      options: [],
      mediaIds: [],
      isPopupEditShow: false,
    }
  },
  computed: {
    ...mapGetters({
      credentialsDropdown: 'dropdown/credentials',
      schoolYears: 'dropdown/schoolYears',
      statuses: 'credentialStorage/statuses',
    }),
    isCreated() {
      return !this.item
    },
    statusOptions() {
      return this.statuses
    },
    trainingSystemLabel() {
      return getUser().orgCode === OrganizationCode.HLUV ? 'Hệ đào tạo' : 'Hình thức đào tạo'
    },
  },
  methods: {
    ...mapActions({
      getAllCredentials: 'dropdown/getAllCredentials',
      getSchoolYears: 'dropdown/getSchoolYears',
      updateCredentialStorage: 'credentialStorage/updateCredentialStorage',
      addCredentialsStorage: 'credentialCreate/addCredentialsStorage',
      updateStatusProcess: 'processRequest/updateStatusProcess',
    }),
    showToast(title, icon, variant) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title,
          icon,
          variant,
        },
      })
    },
    checkPdfExtension(selectedOption) {
      const option = this.options.find(opt => opt.value === selectedOption)
      if (option && option.text && !option.text.endsWith('.pdf')) {
        this.targetItem.credentialFileId = ''
        this.showToast('Định dạng file cần ở dạng pdf', 'XCircleIcon', 'danger')
      } else {
        this.targetItem.credentialFileId = option.value
      }
    },
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },
    async onShow() {
      if (this.credentialProcessReq && this.isCreated) {
        this.targetItem.credentialFileId = ''
      }

      await this.getSchoolYears()
      const [trainingSystems, studyClassifications] = await Promise.all([
        api.getTrainingSystems(),
        apiCommon.getStudyClassifications(),
      ])
      this.trainingSystems = trainingSystems
      this.studyClassifications = studyClassifications

      if (this.item) {
        this.isPopupEditShow = true
        this.targetItem = { ...this.item }
      }
      if (this.credentialProcessReq) {
        this.targetItem.studentId = this.credentialProcessReq.studentId
        this.credentialProcessReq.filesId.forEach((fileId, index) => {
          this.options.push({
            text: this.credentialProcessReq.filesName[index],
            value: fileId,
          })
        })
      }
      if (this.targetItem.birthday) {
        const [day, month, year] = this.targetItem.birthday.split('/')
        this.targetItem.birthday = new Date(`${year}-${month}-${day}`)
      }
    },
    onHide() {
      this.options = []
      this.trainingSystems = []
      this.courses = []
      this.classes = []
      this.studentClasses = []
      this.targetItem = {
        trainingSystemId: '',
        courseId: '',
        classId: '',
        credentialId: '',
        classCode: '',
        studentCode: '',
        decisionNo: '',
        code: '',
        studyClassificationCode: '',
        yearCode: '',
        status: 1,
        credentialFileId: null,
        credentialFileName: '',
        studentId: '',
        id: null,
      }
      this.isPopupEditShow = false
    },
    async onSave(type = null) {
      try {
        const response = this.isCreated ? await this.addCredentialsStorage([this.targetItem]) : await this.updateCredentialStorage(this.targetItem)
        if (response) {
          const { isSuccessful, message } = response
          if (isSuccessful) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: message,
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            if (this.credentialProcessReq) {
              try {
                const responseProcessReq = await this.updateStatusProcess({
                  id: this.credentialProcessReq.id,
                  params: { status: 2 },
                })
                if (responseProcessReq) {
                  const { isSuccessfulReq, messageReq } = responseProcessReq
                  if (isSuccessfulReq) {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: messageReq,
                        icon: 'CheckIcon',
                        variant: 'success',
                      },
                    })
                  } else {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: messageReq,
                        icon: 'XCircleIcon',
                        variant: 'danger',
                      },
                    })
                  }
                }
              } catch (e) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: `[${e.code}] ${e.message}`,
                    icon: 'XCircleIcon',
                    variant: 'danger',
                  },
                })
              }
            }
            if (type === 'hide') {
              this.$bvModal.hide('credentialStorageSaveModal')
            }
            this.$emit('succeed')
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: message,
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            })
          }
        }
        // eslint-disable-next-line no-empty
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      }
    },
    async uploadFile(e) {
      this.isLoading = true
      const formData = new FormData()
      const { files } = e.target
      if (files.length === 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'File tài liệu đang bị trống',
            icon: 'InfoIcon',
            variant: 'warning',
          },
        })
        this.isLoading = false
        return
      }

      files.forEach(file => formData.append('files', file))
      this.mediaIds = await apiCommon.uploadDocument(formData)
      if (this.mediaIds.length > 0) {
        this.showToast('Upload file thành công', 'CheckIcon', 'success')
        this.targetItem.credentialFileId = this.mediaIds[0]
      } else {
        this.showToast('Có lỗi xẩy ra', 'XCircleIcon', 'danger')
      }
      this.isLoading = false
    },
  },
  watch: {
    'targetItem.trainingSystemId': async function (newValue) {
      if (!this.isPopupEditShow) {
        this.targetItem.courseId = ''
        this.targetItem.classCode = ''
        this.targetItem.studentCode = ''
        this.courses = []
        this.classes = []
        this.studentClasses = []
      }

      if (newValue) {
        this.courses = await api.getCoursesByTrainingSystemId({ trainingSystemId: newValue })
      }
    },

    'targetItem.courseId': async function (newValue) {
      if (!this.isPopupEditShow) {
        this.targetItem.classCode = ''
        this.targetItem.studentCode = ''
        this.classes = []
        this.studentClasses = []
      }

      if (newValue) {
        this.classes = await api.getClassesByCourseId({ courseId: newValue })

        // Nếu classCode đang có giá trị sẵn, trigger lại watcher thủ công
        if (this.targetItem.classCode) {
          const saved = this.targetItem.classCode
          this.targetItem.classCode = ''
          this.$nextTick(() => {
            this.targetItem.classCode = saved
          })
        }
      }
    },

    'targetItem.classCode': async function (newValue) {
      if (!this.isPopupEditShow) {
        this.targetItem.studentCode = ''
        this.studentClasses = []
      }

      if (newValue && this.classes.length > 0) {
        const selectedClass = this.classes.find(item => item.code === newValue)
        const classId = selectedClass?.id

        if (classId) {
          this.studentClasses = await api.getStudentsByClassId({ classId })
        }
        this.isPopupEditShow = false
      }
    },
  },
}
</script>

<style scoped lang="scss">

</style>
